import { render, staticRenderFns } from "./audio-component-editor.vue?vue&type=template&id=12173d91"
import script from "./audio-component-editor.vue?vue&type=script&lang=js"
export * from "./audio-component-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports